import {  apiGetRecordUsers,
          apiGetRecordSocialServiceUsers,
          apiGetRecordLanguageReleaseUsers,
          apiGetRecordExchangeValidationUsers,
          apiGetDigitalDegreeUsers
} from '../../api/record'

const getRecordUser = (context, folio) => {
  return new Promise((resolve, reject) => {
    apiGetRecordUsers(folio)
          .then((response) => {
            context.commit('GET_RECORD', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
  })
}

const getRecordSocialServiceUser = (context, folio) => {
  return new Promise((resolve, reject) => {
    apiGetRecordSocialServiceUsers(folio)
          .then((response) => {
            context.commit('GET_RECORD', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
  })
}

const getRecordLanguageReleaseUser = (context, folio) => {
  return new Promise((resolve, reject) => {
    apiGetRecordLanguageReleaseUsers(folio)
          .then((response) => {
            context.commit('GET_RECORD', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
  })
}

const getRecordExchangeValidationUser = (context, folio) => {
  return new Promise((resolve, reject) => {
    apiGetRecordExchangeValidationUsers(folio)
          .then((response) => {
            context.commit('GET_RECORD', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
  })
}

const getDigitalDegreeUser = (context, folio) => {
  return new Promise((resolve, reject) => {
    apiGetDigitalDegreeUsers(folio)
          .then((response) => {
            context.commit('GET_RECORD', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
  })
}

export default {
  getRecordUser,
  getRecordSocialServiceUser,
  getRecordLanguageReleaseUser,
  getRecordExchangeValidationUser,
  getDigitalDegreeUser,
}